'use client';

import { useEffect } from 'react';
import { AppNextLink } from '@/features/app-next-link';
import { IconArrowSquareLeft } from '@/features/icons';
import { HOMEPAGE_VIDEO_SLUG } from '@/app/(home-page)/contants';
import useGetVideos from '@/app/videos/utils/use-get-videos';
import { cn } from '@/utils/cn';
import { getCdnUrl } from '@/utils/url';
import { useLazyImport } from '@/utils/use-lazy-import';
import CarouselContent from './content';
import CarouselSkeleton from './skeleton';
import { useInteractifyParams } from '../utils/use-vid-params';
const magicBoxBg = getCdnUrl('/_toad/images/magic-box-bg.png');
const magicBoxStars = getCdnUrl('/_toad/images/magic-box-stars.svg');
interface Props {
  title?: string;
  slug?: string;
  className?: string;
  productSlug?: string;
  withInfiniteLoading?: boolean;
  componentMeta?: {
    componentId: string;
    sortKey: string;
  };
  isDarkMode?: boolean;
}
const InteractifyCarousel = ({
  title,
  slug,
  className,
  productSlug,
  withInfiniteLoading = false,
  componentMeta,
  isDarkMode = false
}: Props) => {
  const {
    removeInteractifyParam,
    activeInteractifyParam,
    isOpenedFromGallery
  } = useInteractifyParams();
  const {
    ref,
    component: InteractifyVideoModal,
    forceLoad
  } = useLazyImport(() => import('@/features/interactify/video-modal'), {
    threshold: 0.1,
    rootMargin: '100px',
    triggerOnce: true
  });
  const {
    videos,
    isLoading
  } = useGetVideos({
    slug,
    productSlug
  });
  const closeHandler = () => {
    removeInteractifyParam();
  };
  useEffect(() => {
    if (!activeInteractifyParam) return;
    forceLoad();
  }, [forceLoad, activeInteractifyParam]);
  if (!isLoading && !videos.length) return null;
  const isHomePage = slug === HOMEPAGE_VIDEO_SLUG;
  const isInHomeOrLanidng = !!slug;
  const withShowMore = isInHomeOrLanidng && videos.length > 1 && !isDarkMode;
  return <>
            {InteractifyVideoModal && <InteractifyVideoModal isModalOpen={!isOpenedFromGallery && !!activeInteractifyParam} closeHandler={closeHandler} slug={slug} productSlug={productSlug} />}

            <div ref={ref} className={className}>
                <div style={isHomePage ? {
        backgroundImage: `url(${magicBoxBg})`
      } : {}} className={cn(isHomePage ? 'overflow-hidden rounded bg-cover bg-no-repeat p-3 lg:rounded-md lg:p-4' : 'flex flex-col gap-2 lg:gap-3')}>
                    <div className={cn('flex items-center justify-between', {
          hidden: !title && !withShowMore,
          'justify-end': !title
        })}>
                        {title && <div className='relative'>
                                <span className={cn('text-body-14 font-bold text-[var(--landing-text)]', isHomePage ? 'lg:text-title-18' : 'lg:text-body-16')}>
                                    {title}
                                </span>
                                {isHomePage && <img src={magicBoxStars} alt='جعبه جادویی' className='absolute -top-full right-full' />}
                            </div>}

                        {withShowMore && <AppNextLink href='/videos' className='flex items-center gap-1.5 text-body-14 font-medium text-primary-main lg:font-bold'>
                                <span className='whitespace-nowrap'> مشاهده همه </span>
                                {isHomePage && <IconArrowSquareLeft fontSize={20} />}
                            </AppNextLink>}
                    </div>

                    {isHomePage && <span className='mb-3 inline-block text-caption-12 lg:text-body-14'>
                            جدیدترین ویدیوها از محصولات و ترفندهای زیبایی
                        </span>}

                    {isLoading ? <CarouselSkeleton /> : <CarouselContent slug={slug} productSlug={productSlug} componentMeta={componentMeta} withInfiniteLoading={withInfiniteLoading} isDark={isDarkMode} isPdpPage={!!productSlug} />}
                </div>
            </div>
        </>;
};
export default InteractifyCarousel;